import { Badge, Inline, Notice, Text } from '@etg/wings';
import { cx, css, mediaQueries } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const baggageStatusStyles = css`
  width: 85%;

  @media ${mediaQueries.small.only} {
    width: 80%;
  }
`;
const BaggageStatus = _ref => {
  let {
    className,
    dataTestId,
    statusLabel,
    variant,
    description,
    dataOfferRate,
    useNotice = false
  } = _ref;
  return /*#__PURE__*/_jsxs(Inline, {
    alignY: "center",
    className: cx(baggageStatusStyles, className),
    "data-testid": dataTestId,
    ...(dataOfferRate && {
      'data-offer-rate': dataOfferRate
    }),
    children: [/*#__PURE__*/_jsx(Badge, {
      variant: variant,
      children: statusLabel
    }), description && (useNotice ? /*#__PURE__*/_jsx(Notice, {
      variant: "information",
      children: /*#__PURE__*/_jsx(Text, {
        asHtml: true,
        "data-testid": "baggage-status-description",
        children: description
      })
    }) : /*#__PURE__*/_jsx(Text, {
      as: "bdi",
      "data-testid": "baggage-status-description",
      children: description
    }))]
  });
};
export default BaggageStatus;
//# sourceMappingURL=BaggageStatus.js.map